import TextPollItem from "./TextPollItem";

const PostTextPoll = () => {
    return (
        <div className="post-text-poll-wrapper d-flex flex-col flex-j-center flex-a-center gap-15 pt-20 pb-20">
            <TextPollItem option="option 1" percent={30} />
            <TextPollItem option="option 2" percent={50} />
            <TextPollItem option="option 3" percent={20} />
        </div>
    );
};

export default PostTextPoll;
